// eslint-disable-next-line
export const NAME_REGEX = /^[^<>%$!"\*]{1,255}$/
export const MERCHANT_ID_REGEX = /^\w{1,9}$/
